import React, { useEffect, useState } from "react";
import courses from "../../AdmissionFom/courses";

const ProfileEdit = ({
  studentDetails,
  StudentChalanDetails,
  handleStudentImageChange,
  handleInputChange,
  setStudentChalanDetails,
  handleSubmit,
  studentImagePreview,
  completeProfile,
  setcompleteProfile,
  error,
  setError,
}) => {
  // const course = [
  //   {
  //     course_name: "B.COM",
  //     course_level: "UG",
  //   },
  //   {
  //     course_name: "B.SC (BIO)",
  //     course_level: "UG",
  //   },
  //   {
  //     course_name: "B.SC (Maths)",
  //     course_level: "UG",
  //   },
  //   {
  //     course_name: "M.COM",
  //     course_level: "PG",
  //   },
  //   {
  //     course_name: "M.SC (Botany)",
  //     course_level: "PG",
  //   },
  //   {
  //     course_name: "M.SC (Zoology)",
  //     course_level: "PG",
  //   },
  //   {
  //     course_name: "M.SC (Chemistry)",
  //     course_level: "PG",
  //   },
  //   {
  //     course_name: "M.SC (Maths)",
  //     course_level: "PG",
  //   },
  //   {
  //     course_name: "M.SC (Physics)",
  //     course_level: "PG",
  //   },
  // ];

  // State to track filtered courses
  const [filteredCourses, setFilteredCourses] = useState([]);

  // Update filtered courses when academic level changes
  useEffect(() => {
    if (StudentChalanDetails.academic_level) {

      const filtered = courses.filter(
        (c) => c.type === StudentChalanDetails.academic_level
      );
      setFilteredCourses(filtered);
      
      // If current course is not in the filtered list, reset course selection
      if (StudentChalanDetails.course_name && 
          !filtered.some(c => c.course_name === StudentChalanDetails.course_name)) {
        setStudentChalanDetails({
          ...StudentChalanDetails,
          course_name: ""
        });
      }
    } else {
      setFilteredCourses([]);
    }
  }, [StudentChalanDetails.academic_level]);

  const [selectedType, setSelectedType] = useState("");

  const [upResidence, setUpResidence] = useState(false);

  const up = (e) => {
    const { value } = e.target;
    setUpResidence(!upResidence);
    const sameState = value ==="No"?0:1;
    setStudentChalanDetails({
        ...StudentChalanDetails,
        same_state:sameState
      });
    if (value === "No")
      setStudentChalanDetails({
        ...StudentChalanDetails,
        category: "GENERAL",
      });
    console.log(value);
    console.log(StudentChalanDetails);
  };

  return (
    <div className="chalan-payment-modal-overlay">
      <div className="student-profile-container-modal">
        {/* Modal Header with Close Button */}

        {/* <button onClick={() => console.log(StudentChalanDetails)}>error</button> */}

        <div className="chalan-payment-modal-header">
          <h2 className="chalan-payment-modal-title">Student Profile</h2>
          <button
            onClick={() => {
              setcompleteProfile(!completeProfile);
              setError([]);
            }}
            className="chalan-payment-modal-close"
          >
            <svg
              className="chalan-payment-modal-close-icon"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div className="student-profile-container">
          <form className="student-profile-form" onSubmit={handleSubmit}>
            <div className="title-complete-profile">
              <h2 className="title-complete-profile">Personal Information</h2>
            </div>
            <div className="student-profile-section-2">
              <div className="student-profile-field">
                <label>Select Profile Image</label>
                <p className="Error-text">
                  {error.length === 0
                    ? ""
                    : error.profile_photo
                    ? error.profile_photo[0]
                    : ""}
                </p>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleStudentImageChange}
                  className="student-profile-image-input"
                />
              </div>
              <div className="image-preview-profile">
                {studentImagePreview && (
                  <img
                    src={
                      studentImagePreview || StudentChalanDetails.profile_photo
                    }
                    alt="Preview"
                    className="student-profile-image-preview"
                  />
                )}
              </div>
            </div>

            <div className="student-profile-section">
              <div className="student-profile-field">
                <label>Full Name</label>
                <input
                  type="text"
                  name="studentName"
                  disabled={true}
                  value={studentDetails.name}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="student-profile-field">
                <label>Gender</label>
                <p className="Error-text">
                  {error.length === 0
                    ? ""
                    : error.gender
                    ? error.gender[0]
                    : ""}
                </p>
                <select
                  name="gender"
                  value={StudentChalanDetails.gender}
                  onChange={handleInputChange}
                  required
                >
                  <option >Select Gender</option>
                  <option value="M">Male</option>
                  <option value="F">Female</option>
                  <option value="O">Other</option>
                </select>
              </div>

              <div className="student-profile-field">
                <label>Resident Of UP ?</label>
                <p className="Error-text">
                  {error.length === 0
                    ? ""
                    : error.category
                    ? error.category[0]
                    : ""}
                </p>

                <select name="category" onChange={up} required>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>

              {upResidence ? (
                <div className="student-profile-field">
                  <label>Category</label>
                  <p className="Error-text">
                    {error.length === 0
                      ? ""
                      : error.category
                      ? error.category[0]
                      : ""}
                  </p>

                  <select
                    name="category"
                    value={StudentChalanDetails.category || "GENERAL"}
                    onChange={handleInputChange}
                    required
                    disabled={true}
                  >
                    <option>GENERAL</option>
                  </select>
                </div>
              ) : (
                <div className="student-profile-field">
                  <label>Category</label>
                  <p className="Error-text">
                    {error.length === 0
                      ? ""
                      : error.category
                      ? error.category[0]
                      : ""}
                  </p>

                  <select
                    name="category"
                    value={StudentChalanDetails.category}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select Type</option>
                    <option>GENERAL</option>
                    <option>OBC</option>
                    <option>SC</option>
                    <option>ST</option>
                  </select>
                </div>
              )}

              <div className="student-profile-field">
                <label>Email</label>
                <input
                  type="text"
                  name="emailId"
                  disabled={true}
                  value={studentDetails.email}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="student-profile-field">
                <label>Phone</label>
                <input
                  type="text"
                  name="phone_number"
                  disabled={true}
                  value={studentDetails.phone_number}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>

            <div>
              <h2 className="title-complete-profile">Course Information</h2>
            </div>
            <div className="student-profile-section">
              <div className="student-profile-field">
                <label>Academic Level</label>
                <p className="Error-text">
                  {error.length === 0
                    ? ""
                    : error.academic_level
                    ? error.academic_level[0]
                    : ""}
                </p>
                <select
                  name="academic_level"
                  value={StudentChalanDetails.academic_level}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select Level</option>
                  <option>UG</option>
                  <option>PG</option>
                </select>
              </div>

              <div className="student-profile-field">
                <label>Type of Admission</label>
                <select
                  name="admission_code"
                  value={StudentChalanDetails.admission_code}
                  onChange={(e) => {
                    setStudentChalanDetails({
                      ...StudentChalanDetails,
                      admission_code: e.target.value,
                      refrence_roll:
                        e.target.value === "New"
                          ? ""
                          : StudentChalanDetails.refrence_roll,
                    });
                  }}
                  required
                >
                  <option value="">Select Type</option>
                  <option value="New">New</option>
                  <option value="Renewal">Renewal</option>
                </select>
              </div>

              <div className="student-profile-field">
                <label>Course Name</label>
                <p className="Error-text">
                  {error.length === 0
                    ? ""
                    : error.course_name
                    ? error.course_name[0]
                    : ""}
                </p>
                <select
                  name="course_name"
                  value={StudentChalanDetails.course_name}
                  onChange={handleInputChange}
                  required
                  disabled={!StudentChalanDetails.academic_level}
                >
                  <option value="">Select Course</option>
                  {filteredCourses.map((courseItem) => (
                    <option key={courseItem.code} value={courseItem.code}>
                      {courseItem.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="student-profile-field">
                <label>Course Year</label>
                <p className="Error-text">
                  {error.length === 0
                    ? ""
                    : error.course_year
                    ? error.course_year[0]
                    : ""}
                </p>
                <select
                  name="course_year"
                  value={StudentChalanDetails.course_year}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select Year</option>
                  <option value={1}>First Year</option>
                  <option value={2}>Second Year</option>
                  <option value={3}>Third Year</option>
                </select>
              </div>
              {StudentChalanDetails.admission_code === "Renewal" ? (
                <div className="student-profile-field">
                  <label>Roll Number</label>
                  <input
                    type="text"
                    name="refrence_roll"
                    value={StudentChalanDetails.refrence_roll || ""}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              ) : null}
            </div>
          </form>
        </div>

        <div className="chalan-payment-modal-header">
          <h2 className="chalan-payment-modal-title"></h2>
          <button
            onClick={() => handleSubmit()}
            className="chalan-payment-modal-close"
          >
            <button type="submit" className="student-profile-save-btn">
              Save Profile
            </button>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileEdit;